/**
 * Below enums are copy pasted from static/charting_library/charting_library.d.ts
 * */

export enum HHistDirection {
	LeftToRight = 'left_to_right',
	RightToLeft = 'right_to_left'
}
export enum LineStudyPlotStyle {
	/**
	 * Line plot style.
	 */
	Line = 0,
	/**
	 * Histogram plot style.
	 */
	Histogram = 1,
	/**
	 * Cross plot style.
	 */
	Cross = 3,
	/**
	 * Area plot style.
	 */
	Area = 4,
	/**
	 * Column plot style.
	 */
	Columns = 5,
	/**
	 * Circles plot style.
	 */
	Circles = 6,
	/**
	 * Line with breaks plot style.
	 */
	LineWithBreaks = 7,
	/**
	 * Area with breaks plot style.
	 */
	AreaWithBreaks = 8,
	/**
	 * Step line plot style.
	 */
	StepLine = 9,
	/**
	 * Step line with diamonds plot style.
	 */
	StepLineWithDiamonds = 10,
	/**
	 * Step line with breaks, like LineWithBreaks
	 */
	StepLineWithBreaks = 11
}
export enum LineStyle {
	/**
	 * Solid line style.
	 */
	Solid = 0,
	/**
	 * Dotted line style.
	 */
	Dotted = 1,
	/**
	 * Dashed line style.
	 */
	Dashed = 2
}
export enum MarkLocation {
	AboveBar = 'AboveBar',
	BelowBar = 'BelowBar',
	Top = 'Top',
	Bottom = 'Bottom',
	Right = 'Right',
	Left = 'Left',
	Absolute = 'Absolute',
	AbsoluteUp = 'AbsoluteUp',
	AbsoluteDown = 'AbsoluteDown'
}
export enum OrderOrPositionMessageType {
	Information = 'information',
	Warning = 'warning',
	Error = 'error'
}
export enum PlotSymbolSize {
	Auto = 'auto',
	Tiny = 'tiny',
	Small = 'small',
	Normal = 'normal',
	Large = 'large',
	Huge = 'huge'
}
export enum StopType {
	StopLoss = 0,
	TrailingStop = 1
}
export const enum ActionId {
	ChartAddIndicatorToAllCharts = 'Chart.AddIndicatorToAllCharts',
	ChartAddSymbolToWatchList = 'Chart.AddSymbolToWatchList',
	ChartApplyIndicatorsToAllCharts = 'Chart.ApplyIndicatorsToAllCharts',
	ChartChangeTimeZone = 'Chart.ChangeTimeZone',
	ChartClipboardCopyPrice = 'Chart.Clipboard.CopyPrice',
	ChartClipboardCopyLineTools = 'Chart.Clipboard.CopyLineTools',
	ChartClipboardCopySource = 'Chart.Clipboard.CopySource',
	ChartClipboardPasteSource = 'Chart.Clipboard.PasteSource',
	ChartCrosshairLockVerticalCursor = 'Chart.Crosshair.LockVerticalCursor',
	ChartCrosshairPlusButtonDrawHorizontalLine = 'Chart.Crosshair.PlusButton.DrawHorizontalLine',
	ChartCustomActionId = 'Chart.CustomActionId',
	ChartDialogsShowChangeInterval = 'Chart.Dialogs.ShowChangeInterval',
	ChartDialogsShowChangeSymbol = 'Chart.Dialogs.ShowChangeSymbol',
	ChartDialogsShowCompareOrAddSymbol = 'Chart.Dialogs.ShowCompareOrAddSymbol',
	ChartDialogsShowGeneralSettings = 'Chart.Dialogs.ShowGeneralSettings',
	ChartDialogsShowGeneralSettingsLegendTab = 'Chart.Dialogs.ShowGeneralSettings.LegendTab',
	ChartDialogsShowGeneralSettingsSymbolTab = 'Chart.Dialogs.ShowGeneralSettings.SymbolTab',
	ChartDialogsShowGeneralScalesTab = 'Chart.Dialogs.ShowGeneralSettings.ScalesTab',
	ChartDialogsShowGoToDate = 'Chart.Dialogs.ShowGoToDate',
	ChartDialogsShowInsertIndicators = 'Chart.Dialogs.ShowInsertIndicators',
	ChartDialogsShowSymbolInfo = 'Chart.Dialogs.ShowSymbolInfo',
	ChartDrawingToolbarToggleVisibility = 'Chart.DrawingToolbar.ToggleVisibility',
	ChartExternalActionId = 'Chart.ExternalActionId',
	ChartFavoriteDrawingToolsToolbarHide = 'Chart.FavoriteDrawingToolsToolbar.Hide',
	ChartIndicatorShowSettingsDialog = 'Chart.Indicator.ShowSettingsDialog',
	ChartLegendToggleLastDayChangeValuesVisibility = 'Chart.Legend.ToggleLastDayChangeValuesVisibility',
	ChartLegendToggleBarChangeValuesVisibility = 'Chart.Legend.ToggleBarChangeValuesVisibility',
	ChartLegendTogglePriceSourceVisibility = 'Chart.Legend.TogglePriceSourceVisibility',
	ChartLegendToggleIndicatorArgumentsVisibility = 'Chart.Legend.ToggleIndicatorArgumentsVisibility',
	ChartLegendToggleIndicatorTitlesVisibility = 'Chart.Legend.ToggleIndicatorTitlesVisibility',
	ChartLegendToggleIndicatorValuesVisibility = 'Chart.Legend.ToggleIndicatorValuesVisibility',
	ChartLegendToggleOhlcValuesVisibility = 'Chart.Legend.ToggleOhlcValuesVisibility',
	ChartLegendToggleOpenMarketStatusVisibility = 'Chart.Legend.ToggleOpenMarketStatusVisibility',
	ChartLegendToggleSymbolVisibility = 'Chart.Legend.ToggleSymbolVisibility',
	ChartLegendToggleVolumeVisibility = 'Chart.Legend.ToggleVolumeVisibility',
	ChartLines = 'Chart.Lines',
	ChartLinesToggleBidAskLinesVisibility = 'Chart.Lines.ToggleBidAskLinesVisibility',
	ChartLinesToggleHighLowLinesVisibility = 'Chart.Lines.ToggleHighLowLinesVisibility',
	ChartLinesToggleAverageLineVisibility = 'Chart.Lines.ToggleAverageLineVisibility',
	ChartLinesToggleSeriesPrevCloseLineVisibility = 'Chart.Lines.ToggleSeriesPrevCloseLineVisibility',
	ChartLinesToggleSeriesPriceLineVisibility = 'Chart.Lines.ToggleSeriesPriceLineVisibility',
	ChartLineToolBarsPatternToggleFlipped = 'Chart.LineTool.BarsPattern.ToggleFlipped',
	ChartLineToolBarsPatternToggleMirrored = 'Chart.LineTool.BarsPattern.ToggleMirrored',
	ChartLineToolClone = 'Chart.LineTool.Clone',
	ChartLineToolCreateLimitOrderFromState = 'Chart.LineTool.CreateLimitOrderFromState',
	ChartLineToolElliotChangeDegreeProperty = 'Chart.LineTool.Elliot.ChangeDegreeProperty',
	ChartLineToolNoSync = 'Chart.LineTool.NoSync',
	ChartLineToolPitchforkChangeTypeToInside = 'Chart.LineTool.Pitchfork.ChangeTypeToInside',
	ChartLineToolPitchforkChangeTypeToModifiedSchiff = 'Chart.LineTool.Pitchfork.ChangeTypeToModifiedSchiff',
	ChartLineToolPitchforkChangeTypeToOriginal = 'Chart.LineTool.Pitchfork.ChangeTypeToOriginal',
	ChartLineToolPitchforkChangeTypeToSchiff = 'Chart.LineTool.Pitchfork.ChangeTypeToSchiff',
	ChartLineToolSyncInLayout = 'Chart.LineTool.SyncInLayout',
	ChartLineToolTemplates = 'Chart.LineTool.Templates',
	ChartLineToolTemplatesApply = 'Chart.LineTool.Templates.Apply',
	ChartLineToolTemplatesApplyDefaults = 'Chart.LineTool.Templates.ApplyDefaults',
	ChartLineToolTemplatesSaveAs = 'Chart.LineTool.Templates.SaveAs',
	ChartLineToolToolbarChangeFontSizeProperty = 'Chart.LineTool.Toolbar.ChangeFontSizeProperty',
	ChartLineToolToolbarChangeLineStyleToDashed = 'Chart.LineTool.Toolbar.ChangeLineStyleToDashed',
	ChartLineToolToolbarChangeLineStyleToDotted = 'Chart.LineTool.Toolbar.ChangeLineStyleToDotted',
	ChartLineToolToolbarChangeLineStyleToSolid = 'Chart.LineTool.Toolbar.ChangeLineStyleToSolid',
	ChartMarksToggleVisibility = 'Chart.Marks.ToggleVisibility',
	ChartMoveChartInLayout = 'Chart.MoveChartInLayout',
	ChartMoveChartInLayoutBack = 'Chart.MoveChartInLayout.Back',
	ChartMoveChartInLayoutForward = 'Chart.MoveChartInLayout.Forward',
	ChartObjectTreeShow = 'Chart.ObjectTree.Show',
	ChartDataWindowShow = 'Chart.DataWindow.Show',
	ChartPaneControlsDeletePane = 'Chart.PaneControls.DeletePane',
	ChartPaneControlsMaximizePane = 'Chart.PaneControls.MaximizePane',
	ChartPaneControlsMinimizePane = 'Chart.PaneControls.MinimizePane',
	ChartPaneControlsMovePaneDown = 'Chart.PaneControls.MovePaneDown',
	ChartPaneControlsMovePaneUp = 'Chart.PaneControls.MovePaneUp',
	ChartPaneControlsCollapsePane = 'Chart.PaneControls.CollapsePane',
	ChartPaneControlsRestorePane = 'Chart.PaneControls.RestorePane',
	ChartPriceScaleLabels = 'Chart.PriceScale.Labels',
	ChartPriceScaleLabelsToggleBidAskLabelsVisibility = 'Chart.PriceScale.Labels.ToggleBidAskLabelsVisibility',
	ChartPriceScaleLabelsToggleHighLowPriceLabelsVisibility = 'Chart.PriceScale.Labels.ToggleHighLowPriceLabelsVisibility',
	ChartPriceScaleLabelsToggleAveragePriceLabelVisibility = 'Chart.PriceScale.Labels.ToggleAveragePriceLabelVisibility',
	ChartPriceScaleLabelsToggleIndicatorsNameLabelsVisibility = 'Chart.PriceScale.Labels.ToggleIndicatorsNameLabelsVisibility',
	ChartPriceScaleLabelsToggleIndicatorsValueLabelsVisibility = 'Chart.PriceScale.Labels.ToggleIndicatorsValueLabelsVisibility',
	ChartPriceScaleLabelsToggleNoOverlappingLabelsVisibility = 'Chart.PriceScale.Labels.ToggleNoOverlappingLabelsVisibility',
	ChartPriceScaleLabelsToggleSeriesLastValueVisibility = 'Chart.PriceScale.Labels.ToggleSeriesLastValueVisibility',
	ChartPriceScaleLabelsToggleSymbolNameLabelsVisibility = 'Chart.PriceScale.Labels.ToggleSymbolNameLabelsVisibility',
	ChartPriceScaleLabelsToggleSymbolPrevCloseValueVisibility = 'Chart.PriceScale.Labels.ToggleSymbolPrevCloseValueVisibility',
	ChartPriceScaleMergeAllScales = 'Chart.PriceScale.MergeAllScales',
	ChartPriceScaleMergeAllScalesToLeft = 'Chart.PriceScale.MergeAllScalesToLeft',
	ChartPriceScaleMergeAllScalesToRight = 'Chart.PriceScale.MergeAllScalesToRight',
	ChartPriceScaleMoveToLeft = 'Chart.PriceScale.MoveToLeft',
	ChartPriceScaleMoveToRight = 'Chart.PriceScale.MoveToRight',
	ChartPriceScaleReset = 'Chart.PriceScale.Reset',
	ChartPriceScaleToggleAddOrderPlusButtonVisibility = 'Chart.PriceScale.ToggleAddOrderPlusButtonVisibility',
	ChartPriceScaleToggleAutoScale = 'Chart.PriceScale.ToggleAutoScale',
	ChartPriceScaleToggleAutoScaleSeriesOnly = 'Chart.PriceScale.ToggleAutoScaleSeriesOnly',
	ChartPriceScaleToggleCountdownToBarCloseVisibility = 'Chart.PriceScale.ToggleCountdownToBarCloseVisibility',
	ChartPriceScaleToggleIndexedTo100 = 'Chart.PriceScale.ToggleIndexedTo100',
	ChartPriceScaleToggleInvertScale = 'Chart.PriceScale.ToggleInvertScale',
	ChartPriceScaleToggleLogarithmic = 'Chart.PriceScale.ToggleLogarithmic',
	ChartPriceScaleTogglePercentage = 'Chart.PriceScale.TogglePercentage',
	ChartPriceScaleToggleRegular = 'Chart.PriceScale.ToggleRegular',
	ChartRedo = 'Chart.Redo',
	ChartRemoveAllIndicators = 'Chart.RemoveAllIndicators',
	ChartRemoveAllIndicatorsAndLineTools = 'Chart.RemoveAllIndicatorsAndLineTools',
	ChartRemoveAllLineTools = 'Chart.RemoveAllLineTools',
	ChartScalesReset = 'Chart.Scales.Reset',
	ChartScalesToggleLockPriceToBarRatio = 'Chart.Scales.ToggleLockPriceToBarRatio',
	ChartScrollToLineTool = 'Chart.ScrollToLineTool',
	ChartSelectedObjectHide = 'Chart.SelectedObject.Hide',
	ChartSelectedObjectRemove = 'Chart.SelectedObject.Remove',
	ChartSelectedObjectShow = 'Chart.SelectedObject.Show',
	ChartSelectedObjectShowSettingsDialog = 'Chart.SelectedObject.ShowSettingsDialog',
	ChartSelectedObjectToggleLocked = 'Chart.SelectedObject.ToggleLocked',
	ChartSeriesPriceScaleToggleAutoScale = 'Chart.Series.PriceScale.ToggleAutoScale',
	ChartSeriesPriceScaleToggleIndexedTo100 = 'Chart.Series.PriceScale.ToggleIndexedTo100',
	ChartSeriesPriceScaleToggleInvertPriceScale = 'Chart.Series.PriceScale.ToggleInvertPriceScale',
	ChartSeriesPriceScaleToggleLogarithmic = 'Chart.Series.PriceScale.ToggleLogarithmic',
	ChartSeriesPriceScaleTogglePercentage = 'Chart.Series.PriceScale.TogglePercentage',
	ChartSeriesPriceScaleToggleRegular = 'Chart.Series.PriceScale.ToggleRegular',
	ChartSessionBreaksToggleVisibility = 'Chart.SessionBreaks.ToggleVisibility',
	ChartSetSession = 'Chart.SetSession',
	ChartSourceChangePriceScale = 'Chart.Source.ChangePriceScale',
	ChartSourceMergeDown = 'Chart.Source.MergeDown',
	ChartSourceMergeUp = 'Chart.Source.MergeUp',
	ChartSourceMoveToNoScale = 'Chart.Source.MoveToNoScale',
	ChartSourceMoveToOtherScale = 'Chart.Source.MoveToOtherScale',
	ChartSourceMoveToPane = 'Chart.Source.MoveToPane',
	ChartSourceUnmergeDown = 'Chart.Source.UnmergeDown',
	ChartSourceUnmergeUp = 'Chart.Source.UnmergeUp',
	ChartSourceVisualOrder = 'Chart.Source.VisualOrder',
	ChartSourceVisualOrderBringForward = 'Chart.Source.VisualOrder.BringForward',
	ChartSourceVisualOrderBringToFront = 'Chart.Source.VisualOrder.BringToFront',
	ChartSourceVisualOrderSendBackward = 'Chart.Source.VisualOrder.SendBackward',
	ChartSourceVisualOrderSendToBack = 'Chart.Source.VisualOrder.SendToBack',
	ChartSourceResetInputPoints = 'Chart.Source.ResetInputPoints',
	ChartTimeScaleReset = 'Chart.TimeScale.Reset',
	ChartUndo = 'Chart.Undo',
	ChartSourceIntervalsVisibility = 'Chart.Source.IntervalsVisibility',
	ChartSourceIntervalsVisibilityCurrentAndAbove = 'Chart.Source.IntervalsVisibility.CurrentAndAbove',
	ChartSourceIntervalsVisibilityCurrentAndBelow = 'Chart.Source.IntervalsVisibility.CurrentAndBelow',
	ChartSourceIntervalsVisibilityOnlyCurrent = 'Chart.Source.IntervalsVisibility.Current',
	ChartSourceIntervalsVisibilityAll = 'Chart.Source.IntervalsVisibility.All',
	ObjectsTreeCreateGroup = 'ObjectsTree.CreateGroup',
	ObjectsTreeRemoveItem = 'ObjectsTree.RemoveItem',
	ObjectsTreeRenameItem = 'ObjectsTree.RenameItem',
	ObjectsTreeToggleItemLocked = 'ObjectsTree.ToggleItemLocked',
	ObjectsTreeToggleItemVisibility = 'ObjectsTree.ToggleItemVisibility',
	TradingCancelOrder = 'Trading.CancelOrder',
	TradingClosePosition = 'Trading.ClosePosition',
	TradingCustomActionId = 'Trading.CustomActionId',
	TradingDOMPlaceLimitOrder = 'Trading.DOMPlaceLimitOrder',
	TradingDOMPlaceMarketOrder = 'Trading.DOMPlaceMarketOrder',
	TradingDOMPlaceStopLimitOrder = 'Trading.DOMPlaceStopLimitOrder',
	TradingDOMPlaceStopOrder = 'Trading.DOMPlaceStopOrder',
	TradingEditOrder = 'Trading.EditOrder',
	TradingModifyPosition = 'Trading.ModifyPosition',
	TradingReversePosition = 'Trading.ReversePosition',
	TradingSellBuyButtonsToggleVisibility = 'Trading.SellBuyButtonsToggleVisibility',
	TradingTradeFromChart = 'Trading.TradeFromChart',
	TradingNoOverlapMode = 'Trading.NoOverlapMode',
	WatchlistAddSelectedSymbolsToCompare = 'Watchlist.AddSelectedSymbolsToCompare ',
	WatchlistAddSymbolToCompare = 'Watchlist.AddSymbolToCompare',
	WatchlistAddSymbolToSection = 'Watchlist.AddSymbolToSection',
	WatchlistAddSymbol = 'Watchlist.AddSymbol',
	WatchlistRemoveSection = 'Watchlist.RemoveSection',
	WatchlistRenameSection = 'Watchlist.RenameSection'
}
export const enum ChartStyle {
	Bar = 0,
	Candle = 1,
	Line = 2,
	Area = 3,
	Renko = 4,
	Kagi = 5,
	PnF = 6,
	LineBreak = 7,
	HeikinAshi = 8,
	HollowCandle = 9,
	Baseline = 10,
	HiLo = 12,
	Column = 13,
	LineWithMarkers = 14,
	Stepline = 15,
	HLCArea = 16
}
/**
 * Mode to clear the marks on the chart.
 */
export const enum ClearMarksMode {
	/** Will clear both bar marks AND timescale marks - default value */
	All = 0,
	/** Will only clear bar marks */
	BarMarks = 1,
	/** Will only clear timescale marks */
	TimeScaleMarks = 2
}
export const enum ConnectionStatus {
	Connected = 1,
	Connecting = 2,
	Disconnected = 3,
	Error = 4
}
/**
 * Filled area type.
 */
export const enum FilledAreaType {
	/**
	 * Filled area type for plots.
	 */
	TypePlots = 'plot_plot',
	/**
	 * Filled area type for bands.
	 */
	TypeHlines = 'hline_hline'
}
/**
 * Market status for the symbol.
 */
export const enum MarketStatus {
	Open = 'market',
	Pre = 'pre_market',
	Post = 'post_market',
	Close = 'out_of_session',
	Holiday = 'holiday'
}
export const enum MenuItemType {
	Separator = 'separator',
	Action = 'action'
}
export const enum NotificationType {
	Error = 0,
	Success = 1
}
export const enum OhlcStudyPlotStyle {
	OhlcBars = 'ohlc_bars',
	OhlcCandles = 'ohlc_candles'
}
export const enum OrderStatus {
	Canceled = 1,
	Filled = 2,
	Inactive = 3,
	Placing = 4,
	Rejected = 5,
	Working = 6
}
export const enum OrderStatusFilter {
	All = 0,
	Canceled = 1,
	Filled = 2,
	Inactive = 3,
	Rejected = 5,
	Working = 6
}
export const enum OrderTicketFocusControl {
	LimitPrice = 1,
	StopPrice = 2,
	TakeProfit = 3,
	StopLoss = 4,
	Quantity = 5
}
export const enum OrderType {
	Limit = 1,
	Market = 2,
	Stop = 3,
	StopLimit = 4
}
/**
 * Plot line style
 */
export const enum OverrideLineStyle {
	/**
	 * Solid line style.
	 */
	Solid = 0,
	/**
	 * Dotted line style.
	 */
	Dotted = 1,
	/**
	 * Dashed line style.
	 */
	Dashed = 2
}
/**
 * Last value label mode.
 */
export const enum OverridePriceAxisLastValueMode {
	/**
	 * Price and % value.
	 */
	LastPriceAndPercentageValue = 0,
	/**
	 * Value according to scale.
	 */
	LastValueAccordingToScale = 1
}
export const enum ParentType {
	Order = 1,
	Position = 2,
	IndividualPosition = 3
}
export const enum PriceScaleMode {
	/** Normal mode of the price scale */
	Normal = 0,
	/** Logarithmic mode of the price scale */
	Log = 1,
	/** Percentage mode of the price scale */
	Percentage = 2,
	/** Indexed to 100 mode of the price scale */
	IndexedTo100 = 3
}
export const enum SeriesType {
	Bars = 0,
	Candles = 1,
	Line = 2,
	Area = 3,
	HeikenAshi = 8,
	HollowCandles = 9,
	Baseline = 10,
	HiLo = 12,
	Column = 13,
	LineWithMarkers = 14,
	Stepline = 15,
	HLCArea = 16,
	Renko = 4,
	Kagi = 5,
	PointAndFigure = 6,
	LineBreak = 7
}
export const enum Side {
	Buy = 1,
	Sell = -1
}
/**
 * Enumeration of the built-in formatters for the Account Manager columns.
 * Refer to the [Value formatters](https://www.tradingview.com/charting-library-docs/latest/trading_terminal/account-manager/value-formatters.md) section for more information.
 */
export const enum StandardFormatterName {
	Date = 'date',
	DateOrDateTime = 'dateOrDateTime',
	Default = 'default',
	Fixed = 'fixed',
	FixedInCurrency = 'fixedInCurrency',
	VariablePrecision = 'variablePrecision',
	FormatQuantity = 'formatQuantity',
	FormatPrice = 'formatPrice',
	FormatPriceForexSup = 'formatPriceForexSup',
	IntegerSeparated = 'integerSeparated',
	LocalDate = 'localDate',
	LocalDateOrDateTime = 'localDateOrDateTime',
	Percentage = 'percentage',
	Pips = 'pips',
	Profit = 'profit',
	ProfitInInstrumentCurrency = 'profitInInstrumentCurrency',
	// eslint-disable-next-line @typescript-eslint/no-shadow
	Side = 'side',
	PositionSide = 'positionSide',
	Status = 'status',
	Symbol = 'symbol',
	Text = 'text',
	Type = 'type',
	MarginPercent = 'marginPercent',
	Empty = 'empty'
}
export const enum StudyInputType {
	Integer = 'integer',
	Float = 'float',
	Price = 'price',
	Bool = 'bool',
	Text = 'text',
	Symbol = 'symbol',
	Session = 'session',
	Source = 'source',
	Resolution = 'resolution',
	Time = 'time',
	BarTime = 'bar_time',
	Color = 'color',
	Textarea = 'text_area'
}
export const enum StudyPlotDisplayTarget {
	None = 0,
	Pane = 1,
	DataWindow = 2,
	PriceScale = 4,
	StatusLine = 8,
	All = 15
}
export const enum StudyPlotType {
	Line = 'line',
	Colorer = 'colorer',
	BarColorer = 'bar_colorer',
	BgColorer = 'bg_colorer',
	TextColorer = 'text_colorer',
	OhlcColorer = 'ohlc_colorer',
	CandleWickColorer = 'wick_colorer',
	CandleBorderColorer = 'border_colorer',
	UpColorer = 'up_colorer',
	DownColorer = 'down_colorer',
	Shapes = 'shapes',
	Chars = 'chars',
	Arrows = 'arrows',
	Data = 'data',
	DataOffset = 'dataoffset',
	OhlcOpen = 'ohlc_open',
	OhlcHigh = 'ohlc_high',
	OhlcLow = 'ohlc_low',
	OhlcClose = 'ohlc_close'
}
export const enum StudyTargetPriceScale {
	Right = 0,
	Left = 1,
	NoScale = 2
}
export const enum TimeFrameType {
	PeriodBack = 'period-back',
	TimeRange = 'time-range'
}
export const enum TimeHoursFormat {
	TwentyFourHours = '24-hours',
	TwelveHours = '12-hours'
}
export const enum VisibilityType {
	AlwaysOn = 'alwaysOn',
	VisibleOnMouseOver = 'visibleOnMouseOver',
	AlwaysOff = 'alwaysOff'
}
